exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".view-report-templates h1 {\n  color: #4a4a4a;\n  font-size: 20px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./client/modules/Report/components/ViewReports/style.scss
// module id = 1005
// module chunks = 0